import { PageContainer } from "../../components/PageComponents";
import { Summary, UserActivity, TransactionsCount } from "./components";
import Leaderboard from "./Leaderboard";

const Dashboard = () => {
  return (
    <PageContainer title="Dashboard">
      <Summary />
      <div className="col-6">
        <div className="row-2">
          <UserActivity />
          <Leaderboard />
        </div>
        <TransactionsCount />
      </div>
    </PageContainer>
  );
};

export default Dashboard;
